import Routers from './Routers/Routers';
import { ThemeProvider as CustomThemeProvider } from './utils/context/ThemeContext';
import { AuthProvider } from './utils/context/AuthContext';
import { UserProvider } from './utils/context/CurrentUser';
import { Toaster } from 'sonner'
import 'react-toastify/dist/ReactToastify.css';

function App() {

  return (
    <div className='bg-neutral-100 dark:bg-neutral-900' style={{ textAlign: 'center', width: '100vw' }}>
          <CustomThemeProvider>
            <AuthProvider>
              <UserProvider>
                <Toaster
                  position="top-right"
                  richColors
                  expand
                  duration={3000}
                 
                />
                <Routers />
              </UserProvider>
            </AuthProvider>
          </CustomThemeProvider>
    </div>
  );
}

export default App;
